export default {
    report: "Stripe Report",
    createdByUser: "Created by user",
    reportLink: "Link to report"
}